import useApi from "@/composables/useApi";
import {debounce} from "lodash";

export default function useLabor() {
    const {fetchResource, updateResource} = useApi()

    const data = () => ({
        labors: {},
        years: [],
    })

    const updateLaborInfo = debounce((type, year, count, services) => {
        updateResource('/v2/finance-and-productivity/labors', {
            type, year, count, services
        });
    }, 400)

    const methods = {
        async fetchData() {
            const response = await fetchResource('/v2/finance-and-productivity/labors')
            this.labors = response.labors
            this.years = response.years
        },

        handleLaborInfoChange(type, year, count, services) {
            updateLaborInfo(type, year, count, services);
        },
    }

    return {
        data,
        methods,
    }
}
